import React, { Children, useMemo } from 'react';
import { Box, Grid } from '@mui/material';
import { getValidChild } from '@helpers';
import { Typography } from '@elements/typography';
import { StyledAcceptButton, StyledPopupContainer, StyledRejectButton } from './popup.styles';
import { PopupContent } from './slots/popup-content';
import { PopupFooter } from './slots/popup-footer';
import { PopupTitle } from './slots/popup-title';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Popup = function Popup(_ref) {
  var children = _ref.children,
      handleClose = _ref.handleClose,
      acceptPopup = _ref.acceptPopup,
      rejectPopup = _ref.rejectPopup,
      popupId = _ref.popupId,
      popUp = _ref.popUp,
      className = _ref.className;
  var childrenArray = Children.toArray(children);
  var title = useMemo(function () {
    return childrenArray.find(getValidChild(PopupTitle));
  }, [childrenArray]);
  var content = useMemo(function () {
    return childrenArray.find(getValidChild(PopupContent));
  }, [childrenArray]);
  var footer = useMemo(function () {
    return childrenArray.find(getValidChild(PopupFooter));
  }, [childrenArray]);
  /**
   * Reject popup.
   *
   * @author Mikhail Siutsou
   * @return {void}
   */

  var handleRejectPopup = function handleRejectPopup() {
    rejectPopup && rejectPopup();
  };
  /**
   * Accept popup.
   *
   * @author Mikhail Siutsou
   * @return {void}
   */


  var handleAcceptPopup = function handleAcceptPopup() {
    acceptPopup && acceptPopup();
  };

  return /*#__PURE__*/_jsxs(StyledPopupContainer, {
    className: className,
    children: [title && /*#__PURE__*/_jsx(PopupTitle, {
      acceptPopup: acceptPopup,
      rejectPopup: rejectPopup,
      handleClose: handleClose,
      popupId: popupId,
      popUp: popUp,
      children: title.props.children
    }), content && /*#__PURE__*/_jsx(PopupContent, {
      acceptPopup: acceptPopup,
      rejectPopup: rejectPopup,
      handleClose: handleClose,
      popupId: popupId,
      popUp: popUp,
      children: content.props.children
    }), footer && /*#__PURE__*/_jsx(PopupFooter, {
      acceptPopup: acceptPopup,
      rejectPopup: rejectPopup,
      handleClose: handleClose,
      popupId: popupId,
      popUp: popUp,
      children: footer.props.children
    }), popUp && popUp.data && (popUp.data.acceptButton || popUp.data.rejectButton) && /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsxs(Grid, {
        container: true,
        spacing: 1,
        justifyContent: {
          md: 'center'
        },
        children: [popUp.data.acceptButton && /*#__PURE__*/_jsx(Grid, {
          item: true,
          xs: 12,
          children: /*#__PURE__*/_jsx(StyledAcceptButton, {
            variant: "contained",
            size: "large",
            color: "internationalOrange",
            onClick: handleAcceptPopup,
            fullWidth: true,
            sx: {
              textTransform: 'uppercase'
            },
            children: /*#__PURE__*/_jsx(Typography, {
              fontWeight: "500",
              fontSize: "18px",
              lineHeight: "normal",
              letterSpacing: "0.5px",
              children: popUp.data.acceptButton
            })
          })
        }), popUp.data.rejectButton && /*#__PURE__*/_jsx(Grid, {
          item: true,
          xs: 12,
          children: /*#__PURE__*/_jsx(StyledRejectButton, {
            variant: "outlined",
            color: "secondary",
            size: "small",
            onClick: handleRejectPopup,
            fullWidth: true,
            children: popUp.data.rejectButton
          })
        })]
      })
    })]
  });
};

Popup.Title = PopupTitle;
Popup.Content = PopupContent;
Popup.Footer = PopupFooter;
export { Popup };